import pluralize from 'pluralize';
import React from 'react';

import ClientRenderedContent from '@components/ClientRenderedContent';
import { subscriber_profile_path } from '@routes';
import { article_path } from '@routes';
import { articleDate } from '@utils/dates';

import styles from './styles.module.scss';

type ArticleAuthor = {
  username: string;
  name: string;
};

export type ArticleAuthors = ArticleAuthor[];

export default function AuthorsLine({
  authors,
  date,
  commentsCount,
  slug,
}: {
  authors: ArticleAuthors;
  date: string;
  commentsCount: number;
  slug: string;
}) {
  return (
    <div className={styles.authorsLine}>
      By{' '}
      {authors.map((author, index) => (
        <span key={index}>
          <a href={subscriber_profile_path(author.username)}>{author.name}</a>
          {index < authors.length - 1 && <span> and </span>}
        </span>
      ))}
      <span>
        {' '}
        &middot; <ClientRenderedContent>{articleDate(date)}</ClientRenderedContent>
      </span>
      {!!commentsCount && (
        <span>
          {' '}
          &middot;{' '}
          <a
            href={article_path(slug, { anchor: 'comments-anchor' })}
            className="track-link"
            data-type="link"
            data-name="article comments"
            data-location="feed"
          >
            {commentsCount} {pluralize('comment', commentsCount)}
          </a>
        </span>
      )}
    </div>
  );
}
